function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "X Circle Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M10,0.0265263158 C15.508774,0.0265263158 19.9736842,4.49143657 19.9736842,10.0002105 C19.9736842,15.5082868 15.508419,19.9738947 10,19.9738947 C4.49158099,19.9738947 0.0263157895,15.5082868 0.0263157895,10.0002105 C0.0263157895,4.49143657 4.49122605,0.0265263158 10,0.0265263158 Z M10,1.02652632 C5.0435108,1.02652632 1.02631579,5.04372132 1.02631579,10.0002105 C1.02631579,14.9560193 5.04388292,18.9738947 10,18.9738947 C14.9561171,18.9738947 18.9736842,14.9560193 18.9736842,10.0002105 C18.9736842,5.04372132 14.9564892,1.02652632 10,1.02652632 Z M7.17874059,6.47131802 L9.99931579,9.29252632 L12.8213647,6.47131802 C13.0166106,6.27603969 13.3331931,6.27601345 13.5284715,6.47125941 C13.7237498,6.66650537 13.723776,6.98308786 13.5285301,7.17836619 L10.7063158,9.99952632 L13.5282143,12.8218443 C13.7234602,13.0171227 13.723434,13.3337052 13.5281557,13.5289511 C13.3328773,13.7241971 13.0162948,13.7241708 12.8210489,13.5288925 L9.99931579,10.7065263 L7.17905638,13.5288925 C6.98381042,13.7241708 6.66722793,13.7241971 6.4719496,13.5289511 C6.27667127,13.3337052 6.27664503,13.0171227 6.47189099,12.8218443 L9.29231579,9.99952632 L6.4715752,7.17836619 C6.27632924,6.98308786 6.27635548,6.66650537 6.47163381,6.47125941 C6.66691214,6.27601345 6.98349463,6.27603969 7.17874059,6.47131802 Z",
  id: "x-circle-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "x-circle-Icon/Global/Delete-Outline",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "x-circle-Swatches/Midnight",
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "x-circle-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#x-circle-path-1"
})));

var SvgXCircle = function SvgXCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/x-circle.572e955c.svg";
export { ForwardRef as ReactComponent };